import React from 'react';
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import PercentageCalculator from './PercentageCalculator';
import ValueOfPercentage from './ValueOfPercentage';
import ValueOfWhatCalculator from './ValueOfWhatCalculator';
import PercentageDifferenceCalculator from './PercentageDifferenceCalculator';
import PercentageChangeCalculator from './PercentageChangeCalculator';
import SharedHelmet from "../Helmet";
const TITLE = 'Percentage Calculator - Accurate Percentage Calculation Tool';
const DESCRIPTION = 'A useful tool for financial and statistical analysis. Easily calculate percentages for numbers. Supports regular and variable percentages, as well as percentage differences between numbers.';
const KEYWORDS = 'percentage, percentage difference, percentage of amount, percentage of number, extract percentage, percentage change, multi-percentage, percentage calculator';
const OG_URL = 'https://do-calculate.com/calculator/en/percentage/';
function Percentage() {
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: '40px' }}>
            <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                The percentage calculator is a comprehensive and practical tool that allows users to extract, know, and calculate percentages from a number or total according to various calculation formulas. It enables users to calculate regular percentages, variable percentages with increase and decrease, as well as the percentage difference between two numbers. This calculator is a powerful and useful tool for financial and statistical analysis, providing ease of use and a simple interface for users to input values easily and get results quickly. Its use in financial calculations, statistical analysis, and estimating increases and decreases makes it an essential tool for individuals and professionals in various fields.
                <br />
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className='p-3 mb-2 bg-success text-white'>
                  <h2 style={{ fontSize: '16px' }}>Calculate Percentage</h2>
                </div>
                <hr />
                <PercentageCalculator />
                <hr />
                <ValueOfPercentage />
                <hr />
                <ValueOfWhatCalculator />
                <hr />
                <PercentageDifferenceCalculator />
                <hr />
                <PercentageChangeCalculator />
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList CalculatorsTypeId={CalculatorsType.mathCalculators}></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: 'auto' }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Percentage Calculator Description</div>
              <div className="info-section-body">
                <div>
                  <u><h2 style={{ fontSize: '16px' }}>Percentage</h2></u>
                  <p>
                    A percentage is a measurement that expresses a number or quantity as a fraction of the whole multiplied by 100. Thus, it represents a part of the whole as a percentage.
                  </p>
                  <p>
                    When calculating the percentage of a number or quantity, we divide the desired number to be measured by the total value, then multiply the result by 100 to express it as a percentage.
                  </p>
                  <p>
                    The mathematical formula for calculating a percentage is as follows:
                    Percentage = (Desired Number to be Measured ÷ Total Value) × 100
                  </p>
                  <div className='p-3 mb-2 bg-info'>
                    For example, if we have 10 bubbles, and among them, 2 bubbles are red, the percentage of red bubbles would be calculated as follows:
                    (2 ÷ 10) × 100 = 0.2 × 100 = 20%
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u><h2 style={{ fontSize: '16px' }}>Percentage Change Calculator</h2></u>
                  <p>
                    This calculator calculates the increase or decrease using percentages. When using it, the user enters two values:
                  </p>
                  <ul>
                    <li>Value 1: The first value for which you want to calculate the percentage.</li>
                    <li>Value 2: The percentage you want to use for the calculation, whether it's an increase or a decrease.</li>
                  </ul>
                  <p>
                    After entering these two values, the user clicks the "Calculate" button. Then, the calculator calculates the target value and displays it as a percentage.
                  </p>
                  <div className='p-3 mb-2 bg-info'>
                    Let's assume we have a value of 100, and we want to calculate what it will be after increasing it by 10%. We enter these two values in the inputs, choose "Increase" from the selection box, and enter the percentage "10". After clicking the "Calculate" button, the calculator calculates the final value and displays it. In this example, the final value will be 110, which means the value of 100 increased by 10%.
                  </div>
                  <hr />
                </div>
                <div>
                  <u><h2 style={{ fontSize: '16px' }}>Percentage Difference Calculator</h2></u>
                  <p>
                    This calculator allows the user to calculate the percentage difference between two values. When using it, the user enters the following values:
                  </p>
                  <ul>
                    <li>Value 1: The first value for which you want to calculate the percentage difference with another value.</li>
                    <li>Value 2: The second value for which you want to calculate the percentage difference with the first value.</li>
                  </ul>
                  <p>
                    After entering these values, the user clicks the "Calculate" button. Then, the calculator calculates the percentage difference between the values and displays the result as a percentage.
                  </p>
                  <b>Example</b>
                  <div className='p-3 mb-2 bg-info'>
                    Let's assume we have a value of 100 and a value of 80, and we want to calculate the percentage difference between them. We enter these two values in the inputs and click the "Calculate" button. The calculator calculates the percentage difference between the values, and we get the result as a percentage.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Percentage;
